// src/App.jsx
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import BitcoinCountdown from './BitcoinCountdown';
import NationStateBitcoinHoldings from './NationStateBitcoinHoldings';

function App() {
  return (
    <div className="app-container bg-dark text-white">
      <div className="container py-5">
        <h1 className="text-center text-warning mb-5">Who's Hashing It Out?</h1>
        <BitcoinCountdown />
        <NationStateBitcoinHoldings />
      </div>
      <footer className="bg-dark text-warning text-center py-3 mt-5">
        <p>
          Content Writer?{' '}
          <button className="btn btn-link text-warning p-0" style={{ textDecoration: 'underline' }}>
            Contact Us
          </button>
        </p>
      </footer>
    </div>
  );
}

export default App;